<h2 mat-dialog-title class="label-orange-color" translate>ecall-off.change-mills</h2>
<mat-dialog-content>
	<div class="copo-simple-dialog-content">
		<div>
			<span translate>ecall-off.do-you-really-want-to-change-mills</span><span> ?</span>
		</div>
		<p>
			<span translate>ecall-off.selection-will-be-rest</span>.
		</p>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="button-group">
	<button type="button" mat-button class="copo-button-font" (click)="cancel()">
		<span translate>filter.cancel</span>
	</button>
	<button type="submit" mat-button class="copo-blue-dark-grey-button" (click)="validate()">
		<span translate>dashboard.validate</span>
	</button>
</mat-dialog-actions>